import { EnkApiError } from "../api/do-request"
import { useEffect, useState, useRef } from "react"
import EnkPdfViewer from "../components/reports/pdf-viewer"
import { EnkIWPServerReports as ApiReports } from "../api/api-iwp-server"
import { useParams, useLocation } from "react-router"
import EnkReportParams from "../components/reports/report-param"
import { EnkDownloadButton } from "../components/common/buttons"
import EnkPageContainer from "../components/page-container"
import EnkContentLoadingAndError from "../components/error-box"
import { useAuth } from "../auth/use-auth"

//Resourcestrings (to be translated)
const rsErrorCaption = "Er is een fout opgetreden bij het ophalen van het rapport: "
const rsUnknownErrorMessage = "Onbekende fout! Bekijk de console voor meer informatie."

//___________________________________________________________________
//EnkShowReport component

export default function EnkShowReport() {
  //state
  const [reportState, setReportState] = useState<"building" | "params" | "showing">("building")
  const [reportParams, setReportParams] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>("")
  const [pdfUrl, setPdfUrl] = useState<string>("")
  const { getCurrentGroupId } = useAuth()

  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  const params = Array.from(queryParams.entries()).map(([key, value]) => `${key}=${value}`)

  const { reportName } = useParams<{ reportName: string }>() as { reportName: string }

  //___________________________________________________________________
  //fetchReport function

  const fetchReport = async (params: string[]) => {
    try {
      const pdfBufferArray = await ApiReports.buildReport(getCurrentGroupId(), reportName || "", params)
      // Clean up previous blob URL if any
      if (pdfUrl) URL.revokeObjectURL(pdfUrl)
      setReportState("showing")
      //const byteArray = new Uint8Array(pdfBufferArray)
      const blob = new Blob([pdfBufferArray], { type: "application/pdf" })
      setPdfUrl(URL.createObjectURL(blob))

      setLoading(false)
    } catch (e) {
      if (e instanceof EnkApiError && e.httpStatusCode == 300) {
        setLoading(false)
        setReportState("params")
        setReportParams(JSON.parse(e.description) as string[])
        return
      }
      const errormsg = e instanceof Error ? e.message : rsUnknownErrorMessage
      setError(rsErrorCaption + errormsg)
      console.error("Failed to fetch report:", e)
    }
  }

  //___________________________________________________________________
  //useEffect

  const hasFetched = useRef(false)
  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true

      void fetchReport(params)
    }
    return () => {
      // Clean up the blob URL when the component unmounts
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl)
        setPdfUrl("")
      }
    }
  })

  //___________________________________________________________________
  //handleDownloadClick function

  const handleDownloadClick = () => {
    if (!pdfUrl) return
    // Use the already created blob URL
    const link = document.createElement("a")
    const downloadname = reportName.split("/").pop()?.split(".")[0] || "report"
    link.href = pdfUrl
    link.download = `${downloadname}.pdf`
    link.click()
  }

  //___________________________________________________________________
  //component

  return (
    <EnkPageContainer>
      <EnkContentLoadingAndError loading={loading} error={error}>
        <header className="flex flex-none items-center justify-between border-b border-gray-200  py-4">
          {/* <h1 className="text-base font-semibold text-gray-900">{rsReportPagetitle + reportName}</h1> */}
          {reportState === "params" && <h1 className="text-base font-semibold text-gray-900">Parameters</h1>}
          <div className="flex-grow"></div>
          {reportState === "showing" && <EnkDownloadButton text="Download" onClick={handleDownloadClick} />}
        </header>

        {reportState === "building" && <p>Rapport voorbereiden...</p>}
        {reportState === "params" && <EnkReportParams params={reportParams} onCommit={(reportParams: string[]) => void fetchReport(reportParams)} />}

        {reportState === "showing" && pdfUrl && <EnkPdfViewer pdfData={pdfUrl} />}
      </EnkContentLoadingAndError>
    </EnkPageContainer>
  )
}
